export const hero = {
  eyebrow: '智慧餐饮解决方案',
  title: '连接门店、厨房、供应链与会员，提升餐饮经营的每一环。',
  desc: '通过数字化工具优化点餐、出餐、库存、营销与经营决策，让餐饮服务更高效、更懂顾客。',
  primaryLabel: '获取方案咨询',
  secondaryLabel: '查看应用场景',
  image:
    'https://readdy.ai/api/search-image?query=Bright%20warm%20modern%20restaurant%20interior%20with%20an%20open%20kitchen%2C%20customers%20ordering%20food%20through%20a%20digital%20self%20service%20kiosk%20tablet%2C%20staff%20preparing%20fresh%20dishes%20behind%20a%20clean%20counter%2C%20soft%20cozy%20warm%20lighting%20with%20a%20hint%20of%20green%20plants%2C%20lively%20yet%20comfortable%20dining%20atmosphere%2C%20warm%20amber%20and%20fresh%20green%20color%20palette%2C%20cinematic%20lifestyle%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=catering-hero-01&orientation=landscape',
  alt: '智慧餐饮解决方案',
  tags: ['扫码点餐', '厨房协同', '会员运营', '供应链', '经营分析'],
};

export const challenge = {
  eyebrow: '行业挑战',
  title: '餐饮经营，难在效率与体验的平衡',
  subtitle: '客流高峰期与日常经营中，餐饮门店面临服务、成本、数据与复购的多重挑战。',
  items: [
    { icon: 'ri-restaurant-line', title: '高峰点餐出餐压力大', desc: '客流集中时段点餐、出餐易拥堵，影响顾客体验与翻台效率。' },
    { icon: 'ri-team-line', title: '人工成本持续上升', desc: '人力依赖程度高，人工成本逐年攀升，压缩门店利润空间。' },
    { icon: 'ri-database-2-line', title: '门店数据分散', desc: '各门店经营数据割裂，总部难以实时掌握整体经营状况。' },
    { icon: 'ri-archive-line', title: '库存损耗难控制', desc: '原料采购与库存管理粗放，损耗、过期与浪费问题突出。' },
    { icon: 'ri-vip-crown-line', title: '会员复购缺乏精细运营', desc: '会员数据沉淀不足，缺乏精细化的复购与营销运营手段。' },
  ],
};

export const values = {
  eyebrow: '核心价值',
  title: '服务提效、厨房协同、经营可视',
  subtitle: '从顾客体验到门店协同，再到总部经营，构建一体化的餐饮数字化能力。',
  items: [
    { icon: 'ri-customer-service-2-line', title: '服务提效', desc: '优化顾客点餐、支付、取餐与评价流程。' },
    { icon: 'ri-restaurant-2-line', title: '厨房协同', desc: '将订单、叫号、后厨制作与出餐状态实时联动。' },
    { icon: 'ri-line-chart-line', title: '经营可视', desc: '统一查看门店营收、菜品表现、库存损耗与会员数据。' },
  ],
};

export const serviceFlow = {
  eyebrow: '方案架构',
  title: '从顾客到后厨，再到经营管理的一体化连接',
  subtitle: '覆盖顾客端、门店端与管理端，以订单流为主线贯通全链路。',
  endpoints: [
    {
      icon: 'ri-smartphone-line',
      title: '顾客端',
      items: ['扫码点餐', '小程序', '会员', '外卖聚合'],
    },
    {
      icon: 'ri-store-2-line',
      title: '门店端',
      items: ['POS', '厨房显示屏', '取餐叫号', '库存盘点'],
    },
    {
      icon: 'ri-dashboard-3-line',
      title: '管理端',
      items: ['门店运营', '供应链管理', '营销活动', '数据分析'],
    },
  ],
  flow: ['顾客下单', '门店接单', '后厨制作', '取餐/配送', '经营分析'],
};

export const scenarios = {
  eyebrow: '应用场景',
  title: '覆盖主流餐饮业态的数字化方案',
  scenarios: [
    {
      id: 'catering-s1',
      icon: 'ri-store-2-line',
      title: '连锁餐饮门店',
      desc: '统一菜单、活动和会员策略；总部实时掌握各门店销售、库存和经营表现。',
      image:
        'https://readdy.ai/api/search-image?query=Bright%20modern%20chain%20restaurant%20interior%20with%20uniform%20branded%20decor%2C%20customers%20ordering%20via%20digital%20tablet%20and%20smartphone%20scanning%20a%20QR%20code%20menu%2C%20staff%20preparing%20food%20behind%20a%20clean%20open%20counter%2C%20warm%20inviting%20lighting%2C%20fresh%20green%20and%20warm%20amber%20color%20palette%2C%20lifestyle%20editorial%20photography%2C%20high%20detail&width=800&height=520&seq=catering-scene-01&orientation=landscape',
      alt: '连锁餐饮门店',
    },
    {
      id: 'catering-s2',
      icon: 'ri-bowl-line',
      title: '食堂与团餐',
      desc: '支持多档口、多支付方式和订餐取餐管理，提升高峰期供餐效率与就餐体验。',
      image:
        'https://readdy.ai/api/search-image?query=Bright%20modern%20cafeteria%20with%20multiple%20food%20counters%20serving%20hot%20dishes%2C%20people%20lining%20up%20with%20trays%20and%20paying%20via%20mobile%20devices%20and%20smart%20cards%2C%20clean%20organized%20dining%20hall%20with%20wooden%20tables%2C%20warm%20natural%20lighting%2C%20warm%20amber%20and%20fresh%20green%20color%20palette%2C%20lifestyle%20editorial%20photography%2C%20high%20detail&width=800&height=520&seq=catering-scene-02&orientation=landscape',
      alt: '食堂与团餐',
    },
    {
      id: 'catering-s3',
      icon: 'ri-cup-line',
      title: '咖啡、茶饮与轻餐',
      desc: '围绕移动点单、会员储值、排队取餐与复购营销，打造更轻量、更便捷的服务闭环。',
      image:
        'https://readdy.ai/api/search-image?query=Bright%20cozy%20coffee%20shop%20and%20tea%20bar%20with%20customers%20ordering%20drinks%20via%20mobile%20app%20and%20self%20service%20kiosk%2C%20barista%20preparing%20fresh%20coffee%20and%20tea%20behind%20a%20wooden%20counter%2C%20warm%20inviting%20lighting%20with%20green%20plants%20decoration%2C%20warm%20amber%20and%20fresh%20green%20color%20palette%2C%20lifestyle%20editorial%20photography%2C%20high%20detail&width=800&height=520&seq=catering-scene-03&orientation=landscape',
      alt: '咖啡、茶饮与轻餐',
    },
  ],
};

export const metrics = {
  eyebrow: '数据成效',
  title: '把每一笔订单，转化为更好的经营决策',
  items: [
    { icon: 'ri-flashlight-line', title: '提升订单处理效率', desc: '优化点餐、出餐与取餐流程，提升高峰期订单处理能力。' },
    { icon: 'ri-error-warning-line', title: '降低错单漏单损耗', desc: '订单与后厨实时联动，减少错单、漏单与原料损耗。' },
    { icon: 'ri-building-2-line', title: '统一多门店数据', desc: '统一各门店经营数据，总部实时掌握整体经营状况。' },
    { icon: 'ri-pie-chart-2-line', title: '识别高贡献菜品', desc: '识别高贡献菜品与会员人群，优化菜单与营销策略。' },
  ],
  dashboard: {
    title: '餐饮经营数据看板',
    rows: [
      { label: '订单处理量', value: '1,286 单/日', pct: 82 },
      { label: '出餐时效', value: '平均 6.2 分钟', pct: 76 },
      { label: '库存预警', value: '3 项待补货', pct: 24 },
      { label: '会员复购率', value: '38%', pct: 38 },
    ],
    note: '以上数据为界面示意，用于展示餐饮数字化经营分析能力，非真实业务数据。',
  },
};

export const cta = {
  eyebrow: '方案咨询',
  title: '让好服务可复制，让好经营可量化。',
  desc: '无论您是连锁餐饮、食堂团餐还是咖啡茶饮品牌，华辉数智都可结合您的业态特点，提供从点餐、后厨到经营管理的一体化智慧餐饮解决方案。',
  primaryLabel: '申请智慧餐饮方案',
  secondaryLabel: '预约产品演示',
  success: '您的需求已提交，我们将尽快与您联系，为您提供适配的智慧餐饮建设建议。',
};